import type { ZodTypeAny } from 'zod';

export const makeEvent = <T extends ZodTypeAny>(eventName: string, schema: T) => {
    return {
        event: eventName,
        schema,
    } as const;
};
